/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './updateActorAccess.defs.js'
export * as $defs from './updateActorAccess.defs.js'
